var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkUnderline',{staticClass:"page-back",attrs:{"border-hover":true},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('SvgIcon',{attrs:{"name":"arrow left"}}),_c('span',[_vm._v(_vm._s(_vm.$t('global.back')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }